


export const SET_ACTIVE_TAB = 'tabs/SET_ACTIVE_TAB';




const initialState = {
  activeTab: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {

    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    default:
      return state;
  }
};


// Set Active tab
export const setActiveTab = (tab) => {
  return {
    type: SET_ACTIVE_TAB,
    payload: tab,
  };
};



// WEBPACK FOOTER //
// ./src/modules/tabs.js